import {
  Box,
  SimpleGrid,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import tableDataComplex from "views/admin/dataTables/variables/tableDataComplex";
import Managers from "../Managers/Managers";
import TableInventory from "./components/ComplexTable";
import ReceivingSector from "./components/ReceivingStor";

export default function Inventory() {
  // Chakra Color Mode
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs variant="soft-rounded" colorScheme="green">
        <TabList pl={8}>
          <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Setor de Recebimento
          </Tab>
          <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Inventário
          </Tab>
          <Tab
            _selected={{
              bg: "#124907",
              color: "white",
            }}
          >
            Gerentes de Produtos
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              {/* <DevelopmentTable tableData={tableDataDevelopment} />
        <CheckTable tableData={tableDataCheck} />
        <ColumnsTable tableData={tableDataColumns} /> */}
              <ReceivingSector tableData={tableDataComplex} />
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              {/* <DevelopmentTable tableData={tableDataDevelopment} />
        <CheckTable tableData={tableDataCheck} />
        <ColumnsTable tableData={tableDataColumns} /> */}
              <TableInventory tableData={tableDataComplex} />
            </SimpleGrid>
          </TabPanel>
          <TabPanel>
            <SimpleGrid
              mb="10px"
              columns={{ sm: 1, md: 1 }}
              spacing={{ base: "20px", xl: "20px" }}
            >
              {/* <DevelopmentTable tableData={tableDataDevelopment} />
        <CheckTable tableData={tableDataCheck} />
        <ColumnsTable tableData={tableDataColumns} /> */}
              <Managers tableData={tableDataComplex} />
            </SimpleGrid>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
